import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Table, Modal, Button, Form, Container } from 'react-bootstrap';
import './FeaturePlatform.css'; // Import the CSS file

const FeaturePlatform = () => {
    const [featurePlatforms, setFeaturePlatforms] = useState([]);
    const [selectedPlatform, setSelectedPlatform] = useState(null);
    const [showUpdateModal, setShowUpdateModal] = useState(false);
    const [showAddModal, setShowAddModal] = useState(false);
    const [imageFile, setImageFile] = useState(null);

    useEffect(() => {
        // Fetch the data when the component mounts
        const fetchFeaturePlatforms = async () => {
            try {
                const response = await axios.get('https://badbunny.badskullgaming.com/api/get-featurePlatform');
                setFeaturePlatforms(response.data.FeaturePlatforms);
            } catch (error) {
                console.error('Error fetching data:', error);
                toast.error('Failed to fetch data');
            }
        };

        fetchFeaturePlatforms();
    }, []);

    const handleImageChange = (e) => {
        setImageFile(e.target.files[0]);
    };

    const handleAdd = async () => {
        const formData = new FormData();
        if (imageFile) {
            formData.append('image', imageFile);
        }

        try {
            const response = await axios.post(
                'https://badbunny.badskullgaming.com/api/store-featurePlatform',
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            );
            console.log('Add response:', response.data);
            toast.success('Feature platform added successfully');
            setFeaturePlatforms((prevPlatforms) => [...prevPlatforms, response.data]);
            setShowAddModal(false);
            setImageFile(null);
        } catch (error) {
            console.error('Error adding platform:', error);
            toast.error('Failed to add feature platform');
        }
    };

    const handleUpdate = async () => {
        if (!selectedPlatform) return;

        const formData = new FormData();
        if (imageFile) {
            formData.append('image', imageFile);
        }

        try {
            const response = await axios.put(
                `https://badbunny.badskullgaming.com/api/update-featurePlatform/${selectedPlatform.id}`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            );
            console.log('Update response:', response.data);
            toast.success('Feature platform updated successfully');
            setShowUpdateModal(false);
            setImageFile(null);
            // Refresh data after update
            setFeaturePlatforms((prevPlatforms) =>
                prevPlatforms.map((platform) =>
                    platform.id === selectedPlatform.id ? { ...platform, image: response.data.image } : platform
                )
            );
        } catch (error) {
            console.error('Error updating platform:', error);
            toast.error('Failed to update feature platform');
        }
    };

    const handleDelete = async (id) => {
        try {
            await axios.delete(`https://badbunny.badskullgaming.com/api/deletefeaturePlatform/${id}`);
            toast.success('Feature platform deleted successfully');
            setFeaturePlatforms((prevPlatforms) => prevPlatforms.filter((platform) => platform.id !== id));
        } catch (error) {
            console.error('Error deleting platform:', error);
            toast.error('Failed to delete feature platform');
        }
    };

    const openUpdateModal = (platform) => {
        setSelectedPlatform(platform);
        setShowUpdateModal(true);
    };

    const closeUpdateModal = () => {
        setShowUpdateModal(false);
        setSelectedPlatform(null);
        setImageFile(null);
    };

    const openAddModal = () => {
        setShowAddModal(true);
    };

    const closeAddModal = () => {
        setShowAddModal(false);
        setImageFile(null);
    };

    return (
        <Container fluid className="feature-platform-container">
            <ToastContainer
                position="top-right"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
            />
            <div className='d-flex justify-content-between my-3 '>
                <h3 className="feature-platform-title">Feature Platforms</h3>
                <Button style={{ backgroundColor: '#FE0000', borderColor: '#FE0000', color: 'var(--bs-white)' }} onClick={openAddModal} className="mb-3 btn-danger">
                    Add New Feature Platform
                </Button>
            </div>
            <Table striped bordered hover responsive>
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Image</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {featurePlatforms.map((platform) => (
                        <tr key={platform.id}>
                            <td>{platform.id}</td>
                            <td>
                                <img
                                    src={`https://badbunny.badskullgaming.com//uploads/platform/${platform.image}`}
                                    alt="Feature Platform"
                                    style={{ width: '100px' }}
                                />
                            </td>
                            <td>
                                <Button variant="danger" onClick={() => openUpdateModal(platform)}>
                                    Update
                                </Button>{' '}
                                <Button variant="danger" onClick={() => handleDelete(platform.id)}>
                                    Delete
                                </Button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>

            {/* Update Modal */}
            <Modal show={showUpdateModal} onHide={closeUpdateModal}>
                <Modal.Header closeButton>
                    <Modal.Title>Update Feature Platform</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group controlId="formFile">
                            <Form.Label>Upload New Image</Form.Label>
                            <Form.Control type="file" onChange={handleImageChange} />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={closeUpdateModal}>
                        Close
                    </Button>
                    <Button variant="danger" onClick={handleUpdate}>
                        Update
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Add Modal */}
            <Modal show={showAddModal} onHide={closeAddModal}>
                <Modal.Header closeButton>
                    <Modal.Title>Add New Feature Platform</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group controlId="formFile">
                            <Form.Label>Upload Image</Form.Label>
                            <Form.Control type="file" onChange={handleImageChange} />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={closeAddModal}>
                        Close
                    </Button>
                    <Button variant="danger" onClick={handleAdd}>
                        Add
                    </Button>
                </Modal.Footer>
            </Modal>
        </Container>
    );
};

export default FeaturePlatform;
